import { t } from 'i18next';

export function mergeAPIError(error: any) {
    if (Array.isArray(error?.errors) && error?.errors.length > 0) {
        const txt = error.errors.map((i: any) => i?.message).join('\n');

        return error?.detail ? `${error?.detail}: - ${txt}` : txt;
    }
    return (
        error?.errors?.[0]?.message ||
        error?.detail ||
        error?.title ||
        error?.error ||
        error?.message
    );
}

export function ErrorMessage(error: string) {
    switch (error) {
        case 'input_error':
            return t('input_error');

        case 'payment_rejected':
            return t('payment_rejected');

        case 'invalid_receiver':
            return t('invalid_receiver');

        case 'insufficient_balance':
            return t('insufficient_balance');

        case 'transaction_failed':
            return t('transaction_failed');

        case 'generic_error':
            return t('transaction_failed');

        case 'user_blocked':
            return t('user_blocked');

        case 'daily_tx_limit_reached':
            return t('daily_tx_limit_reached');

        case 'user_rejected':
            return t('user_rejected');
        // verification error
        case 'verification_rejected':
            return t('verification_rejected');

        case 'max_verifications_reached':
            return t('max_verifications_reached');

        case 'credential_unavailable':
            return t('credential_unavailable');

        case 'malformed_request':
            return t('malformed_request');

        case 'invalid_network':
            return t('invalid_network');

        case 'inclusion_proof_failed':
            return t('inclusion_proof_failed');

        case 'inclusion_proof_pending':
            return t('inclusion_proof_pending');

        case 'unexpected_response':
            return t('unexpected_response');

        case 'invalid_contract':
            return t('invalid_contract');

        case 'simulation_failed':
            return t('simulation_failed');

        case 'invalid_operation':
            return t('invalid_operation');

        case 'network_congestion':
            return t('network_congestion');

        default:
            return error;
    }
}
